import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { getEndpoint, getCurrentUser } from 'src/app/core/services/functions.service';

@Injectable({
    providedIn: 'root'
})
export class SincronizacionSapService {
    ENDPOINT = getEndpoint('coms_sincronizacion_sap');
    //private ENDPOINT = 'http://localhost:8000';
    private readonly currentUser = getCurrentUser();
    
    constructor(private http: HttpClient) {}


    consultarVendedores(periodo: string): Observable<any> {
        return this.http.get(`${this.ENDPOINT}/query-vendedores/${this.currentUser?.c_emp}/${periodo}`);
    }

    consultarComisionamiento(periodo: string): Observable<any> {
        return this.http.get(`${this.ENDPOINT}/query-comisionamiento-vendedor/${this.currentUser?.c_emp}/${periodo}`);
    }

    consultarComisionamientoJefe(periodo: string): Observable<any> {
        return this.http.get(`${this.ENDPOINT}/query-comisionamiento-jefe/${this.currentUser?.c_emp}/${periodo}`);
    }

    consultarAusentismo(periodo: string): Observable<any> {
        return this.http.get(`${this.ENDPOINT}/query-ausentismo/${this.currentUser?.c_emp}/${periodo}`);
    }

    ejecutarLiquidacion(periodo: string): Observable<any> {
        return this.http.post(`${this.ENDPOINT}/ejecutar-liquidacion/${this.currentUser?.c_emp}/${periodo}`, {});
    }
}
